var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: {
      disabledSelect: _vm.disableDropDown || _vm.completed || _vm.showOptions
    }
  }, [_vm.label ? _c('label', {
    attrs: {
      "id": _vm.dropdownId
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _c('button', {
    class: [{
      alert: _vm.alert
    }, 'select', 'focusable'],
    attrs: {
      "aria-controls": _vm.isDropdown ? 'dropdownmenu' : null,
      "aria-haspopup": _vm.isDropdown ? true : null,
      "aria-labelledby": _vm.isDropdown ? _vm.dropdownId : null,
      "role": _vm.isDropdown ? null : 'textbox',
      "id": "select",
      "tabindex": "0"
    },
    on: {
      "click": _vm.openDropDown,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.openDropDown($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.openDropDown($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.openDropDown($event);
      }]
    }
  }, [_c('div', {
    attrs: {
      "id": "input"
    }
  }, [_vm.blinkingText ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.blinkingText,
      "text-step": _vm.stepIndex
    }
  }) : _vm._e()], 1), _vm._m(0)]), _c('ul', {
    staticClass: "options-container",
    attrs: {
      "aria-label": "Dropdown Options",
      "id": "dropdownmenu",
      "role": "menu"
    }
  }, _vm._l(_vm.displayOptions, function (option, index) {
    return _c('li', {
      key: index,
      class: ("option focusable dropdown-" + (_vm.dropdownId) + "-option"),
      attrs: {
        "data-index": index,
        "role": "menuitem",
        "tabindex": "0"
      },
      on: {
        "blur": _vm.handleBlur,
        "focus": function (e) {
          return _vm.focusedOption = e.target;
        },
        "click": function ($event) {
          return _vm.selectOption(option);
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          return _vm.shiftOptionFocus(_vm.displayOptions.length - 1 === index ? index : index + 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.selectOption(option);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          return _vm.shiftOptionFocus(index ? index - 1 : index);
        }]
      }
    }, [_c('p', {
      domProps: {
        "textContent": _vm._s(option.text)
      }
    })]);
  }), 0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrow"
  }, [_c('div')]);
}]

export { render, staticRenderFns }